import type { BillingAddress } from 'libs/pp-rn-shared-types/lib/typescript/src';

export const addressText = (address: BillingAddress) => {
  return `${address.address1}\n${address.city}, ${address.state} \n${address.postcode}`;
};
